import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-261" data-mp="21x22u3jf6kzn">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-line border-l-4 border-l-aqua bg-white p-4 pr-10 text-ink shadow-lift" aria-live="polite" data-id="element-262" data-mp="21yd704gs1ura">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-aqua" aria-label="Cerrar aviso" data-id="element-263" data-mp="hhgylvm3vpdt">
            <XIcon className="h-4 w-4" data-id="element-264" data-mp="1jfrcaqf0q41h" />
          </button>
          <div className="flex gap-3" data-id="element-265" data-mp="1jhaq8ad7c303">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" data-id="element-266" data-mp="1nga2yh56d423" />
            <div data-id="element-267" data-mp="19peuh5yl8oz1">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-teal" data-id="element-268" data-mp="19owm5aynikar">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-269" data-mp="1eh6lfhlnowpp">
                Al completar tu compra, recibís el<br data-id="element-270" data-mp="zs0cv30xhu55" />
                <span className="font-bold text-petrol" data-id="element-271" data-mp="zsjt8faxkah2">Megapack Instrumentación Quirúrgica</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-272" data-mp="14qldv4o08hun">Acceso digital inmediato</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}